<div class="swap-wifi-comp-wrapper">
  <app-header-hifpt></app-header-hifpt>
  <div class="body-wrapper">
    <div class="container">
      <div class="row">
        <div
          class="col-12 mb"
          *ngIf="contractInfo && contractInfo.swap_wifi6_status !== 'VALID'"
        >
          <div class="col-wrapper payment-success">
            <img
              src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/payment-success.svg"
              alt=""
              width="auto"
              height="auto"
              *ngIf="contractInfo.swap_wifi6_status === 'SUCCESS'"
            />
            <div
              class="text-bold"
              *ngIf="contractInfo.swap_wifi6_status === 'SUCCESS'"
            >
              Giao dịch thành công
            </div>
            <img
              src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/payment-fail.png"
              alt=""
              width="auto"
              height="auto"
              *ngIf="contractInfo.swap_wifi6_status !== 'SUCCESS'"
            />
            <div
              class="text-bold"
              *ngIf="contractInfo.swap_wifi6_status !== 'SUCCESS'"
            >
              Đang đợi thanh toán
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
          <div class="col-wrapper" style="min-height: 100%;">
            <div class="title">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/profile-icon.svg"
                alt=""
                width="auto"
                height="auto"
              />
              <span>Thông tin hợp đồng</span>
            </div>
            <div class="item">
              <div class="item-title">Số hợp đồng</div>
              <div class="item-content">
                {{ contractInfo.contract_no }}
              </div>
            </div>
            <div class="item hide-mobile">
              <div class="item-title">Chủ hợp đồng</div>
              <div class="item-content">
                {{ contractInfo.contract_name }} |
                {{ contractInfo.contract_phone }}
              </div>
            </div>
            <div class="item hide-mobile">
              <div class="item-title">Địa chỉ</div>
              <div class="item-content fw-400">
                {{ contractInfo.contrac_address }}
              </div>
            </div>
            <div class="item show-mobile">
              <div class="item-title">
                {{ contractInfo.contract_name }} |
                {{ contractInfo.contract_phone }}
              </div>
              <div class="item-content fw-400">
                {{ contractInfo.contrac_address }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
          <div class="col-wrapper">
            <div class="title">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/info-icon.svg"
                alt=""
                width="auto"
                height="auto"
              />
              <span>Thông tin giao dịch</span>
            </div>
            <div class="item" *ngIf="transactionInfo.service_name">
              <div class="item-title">Gói dịch vụ mới</div>
              <div class="item-content" [innerHTML]="">
                {{ transactionInfo.service_name }}
                <span class="fw-300">({{ transactionInfo.description }}) </span>
              </div>
            </div>
            <div class="item" *ngIf="transactionInfo.time_from">
              <div class="item-title">Thời điểm tính cước mới</div>
              <div class="item-content">{{ transactionInfo.time_from }}</div>
            </div>
            <div class="item" *ngIf="transactionInfo.device_name">
              <div class="item-title">Thiết bị lắp đặt</div>
              <div class="item-content">
                {{ transactionInfo.device_name }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
          <div class="col-wrapper" style="min-height: 100%;">
            <div class="title">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/method-icon.svg"
                alt=""
                width="auto"
                height="auto"
              />
              <span>Hình thức thanh toán</span>
            </div>
            <div class="item">
              <div class="item-title">Hình thức thanh toán</div>
              <a
              class="item-select"
              *ngIf="selectedMethod && paymentMethod && paymentMethod.length > 1"
              (click)="toggleMethod()"
              (clickOutside)="closeMethod()"
            >
              <span>{{ selectedMethod.method_name }}</span>
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/arrow-down.svg"
                alt=""
                width="auto"
                height="auto"
              />
              <div class="list-method" [ngClass]="{ show: showMethod }">
                <a
                  class="method-item"
                  *ngFor="let item of paymentMethod"
                  (click)="selectNewMethod(item, $event)"
                >
                  <img
                    [src]="item.method_img"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                  <div>
                    <span>{{ item.method_name }}</span>
                    <p>{{ item.description }}</p>
                  </div>
                </a>
              </div>
            </a>
            <div class="item-content" *ngIf="paymentMethod && paymentMethod.length === 1">
              {{ paymentMethod[0].method_name }}
            </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
          <div class="col-wrapper" style="min-height: 100%;">
            <div class="title">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/time-icon.svg"
                alt=""
                width="auto"
                height="auto"
              />
              <span>Thời gian lắp đặt</span>
            </div>
            <div
              class="item"
              *ngIf="contractInfo.swap_wifi6_status === 'VALID'"
            >
              <div class="item-title">
                <span class="position-relative">
                  Chọn thời gian lắp đặt
                  <div
                    class="tooltip-date-picker"
                    *ngIf="showDatePicker"
                    (clickOutside)="onClickOutside($event)"
                    [exclude]="'.date-input'"
                  >
                    <mat-calendar
                      [(selected)]="selectedDate"
                      [minDate]="minDate"
                      [maxDate]="maxDate"
                      [headerComponent]="exampleHeader"
                      (selectedChange)="onSelectDate($event)"
                    ></mat-calendar>
                    <div class="time-radio-wrapper">
                      <div class="title text-center">Thời gian</div>
                      <div class="list d-flex align-items-center">
                        <div
                          class="time"
                          *ngFor="let item of listTime; let x = index"
                        >
                          <div class="wrapper">
                            <input
                              type="radio"
                              id="{{ item?.time_slot }}"
                              value="{{ item?.time_slot }}"
                              name="radio-group"
                              [(ngModel)]="firstTime"
                              (ngModelChange)="apointmentTime = item"
                              [attr.disabled]="
                                item.is_available === false ? true : null
                              "
                            />
                            <label for="{{ item.time_slot }}">{{
                              item.time_slot
                            }}</label>
                          </div>
                        </div>
                      </div>
                      <button
                        (click)="handleSelectDateTime()"
                        class="confirm-button"
                      >
                        Xác nhận
                      </button>
                    </div>
                  </div>
                </span>
              </div>
              <div class="item-content">
                <button
                  class="date-input hide-mobile"
                  (click)="toggleDatePicker(dateApointment)"
                >
                  <span>{{ selectedTime?.text }}</span>
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/calendar-icon.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </button>
                <button
                  class="date-input show-mobile"
                  (click)="
                    openPopup('date-picker', {
                      date_appointment: dateApointment,
                      time_installation: timeInstallation,
                      utm_source: utmSource,
                      location_id: locationId ? locationId : undefined,
                      branch_code: utmExtraBranchcode ? utmExtraBranchcode : undefined,
                      mac: utmExtraMac ? utmExtraMac : undefined,
                      contract_no: contractNo,
                      phone_nb: phoneNumber
                    })
                  "
                >
                  <span>{{ selectedTime?.text }}</span>
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/calendar-icon.svg"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </button>
                <div
                  *ngIf="timeInstallation?.is_warning"
                  style="color: red; font-size: 14px; margin-top: 10px"
                >
                  Không có thời gian khả dụng trong
                  {{ timeInstallation.date_limit }} ngày tới
                </div>
              </div>
            </div>
            <div
              class="item"
              *ngIf="contractInfo.swap_wifi6_status !== 'VALID'"
            >
              <div class="item-title">Thời gian lắp đặt</div>
              <div class="item-content">
                {{ selectedTime?.text }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="col-wrapper">
            <div class="title">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/method-icon.svg"
                alt=""
                width="auto"
                height="auto"
              />
              <span>Chi tiết thanh toán</span>
            </div>
            <div
              class="item d-flex align-items-center"
              *ngIf="paymentInfo?.addition_price"
            >
              <div class="left">
                <div class="item-title">
                  <span class="position-relative">
                    Tiền cước internet bổ sung
                    <div
                      class="tool-tip-payment"
                      *ngIf="showTooltip"
                      (clickOutside)="showTooltip = false"
                      [exclude]="'.open-tooltip'"
                    >
                      <h2>Cách tính cước Internet bổ sung</h2>
                      <div class="list-item-wrapper">
                        <div class="item-in-list">
                          <div class="title-item">Gói cước hiện tại</div>
                          <div class="content-item">
                            <div>
                              <span class="text-bold">{{
                                paymentInfo?.addition_detail.current_data
                                  ?.data_name
                              }}</span>
                            </div>
                            <div>
                              <span class="text-bold"
                                >{{
                                  paymentInfo?.addition_detail.current_data
                                    ?.duration
                                }}
                              </span>
                              {{
                                paymentInfo?.addition_detail.current_data?.time
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="item-in-list">
                          <div class="title-item">Gói cước mới</div>
                          <div class="content-item">
                            <div>
                              <span class="text-bold"
                                >{{
                                  paymentInfo?.addition_detail.new_data
                                    ?.data_name
                                }}
                              </span>
                              ({{
                                paymentInfo?.addition_detail.new_data
                                  ?.description
                              }}
                              )
                            </div>
                          </div>
                        </div>
                        <div class="item-in-list">
                          <div class="title-item">Thời điểm tính cước mới</div>
                          <div class="content-item">
                            <div>
                              <span class="text-bold">{{
                                paymentInfo?.addition_detail.t_apply
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="item-in-list">
                          <div class="title-item">
                            Tiền trả trước thu tăng thêm
                          </div>
                          <div class="content-item">
                            <div>
                              <span class="text-bold"
                                >{{
                                  paymentInfo?.addition_detail.addition_price
                                    .fee_str
                                }}
                              </span>
                            </div>
                            <div>
                              {{
                                paymentInfo?.addition_detail.addition_price.time
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                  <a
                    (click)="toggleTooltipPayment()"
                    class="position-relative open-tooltip hide-mobile"
                    *ngIf="paymentInfo?.is_detail"
                  >
                    <img
                      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/warning-icon.svg"
                      alt=""
                      width="auto"
                      height="auto"
                    />
                  </a>
                  <a
                    (click)="openPopup('tool-tip-payment', paymentInfo)"
                    *ngIf="paymentInfo?.is_detail"
                    class="position-relative open-tooltip show-mobile"
                  >
                    <img
                      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/warning-icon.svg"
                      alt=""
                      width="auto"
                      height="auto"
                    />
                  </a>
                </div>
                <div
                  class="sub-title"
                  *ngIf="paymentInfo?.addition_detail?.addition_price.time"
                >
                  ({{ paymentInfo?.addition_detail?.addition_price.time }})
                </div>
              </div>
              <div class="right">
                {{ swapWifiService.convertPrice(paymentInfo?.addition_price) }}đ
              </div>
            </div>
            <div class="item d-flex align-items-center" *ngIf="paymentInfo?.exchange_price">
              <div class="left">
                <div class="item-title">Phí chuyển đổi dịch vụ</div>
              </div>
              <div class="right">
                {{ swapWifiService.convertPrice(paymentInfo?.exchange_price) }}đ
              </div>
            </div>
            <div class="item d-flex align-items-center" *ngIf="paymentInfo?.box_fee">
              <div class="left">
                <div class="item-title">Phí chuyển đổi box</div>
              </div>
              <div class="right">
                {{ swapWifiService.convertPrice(paymentInfo?.box_fee) }}đ
              </div>
            </div>
            <div class="item d-flex">
              <div class="left">
                <div class="item-title special">Tổng thanh toán</div>
              </div>
              <div class="right">
                <div class="text">
                  {{ swapWifiService.convertPrice(paymentInfo?.total_price) }}đ
                  <div class="sub-vat">(Đã bao gồm VAT)</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-12 mt"
          *ngIf="
            contractInfo.swap_wifi6_status === 'VALID' ||
            (contractInfo.swap_wifi6_status !== 'VALID' &&
              contractInfo?.is_retry_payment === 1)
          "
        >
          <div class="col-wrapper">
            <div class="d-flex align-item-center">
              <div class="left flex-grow-1">
                <div class="left-title">Tổng thanh toán</div>
                <div class="amount">
                  {{ swapWifiService.convertPrice(paymentInfo?.total_price) }}đ
                </div>
              </div>
              <div class="right">
                <button (click)="submitPayment()">{{contractInfo.swap_wifi6_status === 'VALID' ? "Xác nhận" : "Thanh toán ngay"}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-hifpt></app-footer-hifpt>
</div>
<app-spinner-layout></app-spinner-layout>
